.Notification {
  --notification-bg: var(--semantic-colors-bg-primary);
  --notification-border: var(--semantic-notifications-success-border);
  --notification-body-color: var(--semantic-notifications-success-body);
  --notification-heading-color: var(--semantic-notifications-success-heading);
  --notification-icon-left-color: var(--semantic-notifications-success-icon-left);
  --notification-icon-right-color: var(--semantic-notifications-success-icon-right);
  --notification-radius: var(--semantics-radius-14);
  --notification-border-width: var(--semantics-border-outline-sm);
  --notification-padding: var(--semantics-units-unit-16);
  --notification-max-width: 450px;
  --notification-icon-size: var(--semantics-units-unit-32);
  --notification-icon-gap: var(--semantics-units-unit-12);
  --notification-content-gap: var(--semantics-units-unit-8);
  --notification-section-gap: var(--semantics-units-unit-24);
  --notification-title-font: var(--font-heading-xs-bold);
  --notification-body-font: var(--font-body-md-regular);
  --notification-close-size: var(--semantics-units-unit-32);

  justify-content: space-between;
  background: var(--notification-bg);
  border: var(--notification-border-width) solid var(--notification-border);
  border-radius: var(--notification-radius);
  color: var(--notification-body-color);
  display: flex;
  flex-direction: column;
  gap: var(--notification-section-gap);
  padding: var(--notification-padding);
  width: min(100%, var(--notification-max-width));
}

.VariantDefault {
  gap: 0;
  justify-content: center;
}

.Top {
  display: flex;
  gap: var(--notification-icon-gap);
  width: 100%;
}

.VariantDefault .Top {
  align-items: center;
}

.VariantTitle .Top {
  align-items: flex-start;
}

.Content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--notification-content-gap);
  min-width: 0;
}

.Title {
  color: var(--notification-heading-color);
  font: var(--notification-title-font);
  letter-spacing: var(--semantics-typography-letter-spacing-body);
}

.Body {
  color: var(--notification-body-color);
  font: var(--notification-body-font);
  letter-spacing: var(--semantics-typography-letter-spacing-body);
}

.Icon {
  align-items: center;
  color: var(--notification-icon-left-color);
  display: inline-flex;
  flex: 0 0 auto;
  height: var(--notification-icon-size);
  justify-content: center;
  width: var(--notification-icon-size);
}

.Icon svg {
  height: 100%;
  width: 100%;
}

.Close {
  align-items: center;
  background: transparent;
  border: none;
  color: var(--notification-icon-right-color);
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  height: var(--notification-close-size);
  justify-content: center;
  padding: 0;
  width: var(--notification-close-size);
}

.Close svg {
  height: 100%;
  width: 100%;
}

.Close:focus-visible {
  outline: 2px solid var(--semantic-colors-other-border);
  outline-offset: 2px;
  border-radius: var(--semantics-radius-999);
}

.Actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--semantics-units-unit-20);
  justify-content: flex-end;
  width: 100%;
}

.SizeMobile {
  --notification-max-width: 400px;
  --notification-icon-size: var(--semantics-units-unit-24);
  --notification-icon-gap: var(--semantics-units-unit-8);
  --notification-content-gap: var(--semantics-units-unit-4);
  --notification-section-gap: var(--semantics-units-unit-16);
  --notification-title-font: var(--font-body-md-bold);
  --notification-body-font: var(--font-body-sm-regular);
  --notification-close-size: var(--semantics-units-unit-24);
}

.ToneSuccess {
  --notification-border: var(--semantic-notifications-success-border);
  --notification-body-color: var(--semantic-notifications-success-body);
  --notification-heading-color: var(--semantic-notifications-success-heading);
  --notification-icon-left-color: var(--semantic-notifications-success-icon-left);
  --notification-icon-right-color: var(--semantic-notifications-success-icon-right);
}

.ToneError {
  --notification-border: var(--semantic-notifications-error-border);
  --notification-body-color: var(--semantic-notifications-error-body);
  --notification-heading-color: var(--semantic-notifications-error-heading);
  --notification-icon-left-color: var(--semantic-notifications-error-icon-left);
  --notification-icon-right-color: var(--semantic-notifications-error-icon-right);
}

.ToneInformation {
  --notification-border: var(--semantic-notifications-information-border);
  --notification-body-color: var(--semantic-notifications-information-body);
  --notification-heading-color: var(--semantic-notifications-information-heading);
  --notification-icon-left-color: var(--semantic-notifications-information-icon-left);
  --notification-icon-right-color: var(--semantic-notifications-information-icon-right);
}

.ToneWarning {
  --notification-border: var(--semantic-notifications-warning-border);
  --notification-body-color: var(--semantic-notifications-warning-body);
  --notification-heading-color: var(--semantic-notifications-warning-heading);
  --notification-icon-left-color: var(--semantic-notifications-warning-icon-left);
  --notification-icon-right-color: var(--semantic-notifications-warning-icon-right);
}

.ToneQuestion {
  --notification-border: var(--semantic-colors-other-border);
  --notification-body-color: var(--semantic-colors-typography-body);
  --notification-heading-color: var(--semantic-colors-typography-heading);
  --notification-icon-left-color: var(--semantic-colors-other-border);
  --notification-icon-right-color: var(--semantic-colors-other-border);
}
